import type { Sorter } from "@suse-o11y/sorter";

const collator = new Intl.Collator(undefined, {
	usage: "sort",
	numeric: true,
	sensitivity: "base",
});

export const alphabeticalSorter: Sorter<string> = (left, right) => collator.compare(left, right);
